export default "__VITE_ASSET__c9f12dff__"